import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  menu: {
    padding: theme.spacing(10, 2, 0),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(2),
    },
  },
  menuButton: {
    height: 36,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(3),
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  menuButtonText: {
    color: theme.palette.common.white,
  },
  menuButtonTextUser: {
    marginLeft: theme.spacing(2),
  },
  menuButtonAvatar: {
    marginBottom: theme.spacing(2),
    padding: 0,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  menuButtonClose: {
    overflow: 'hidden',
  },
  menuAvatar: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2),
  },
  userNameText: {
    marginLeft: theme.spacing(2),
    '& > span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  menuButtonIcon: {
    minWidth: 0,
    marginRight: theme.spacing(2),
    color: theme.palette.common.white,
  },
  menuSecondary: {
    marginTop: 'auto',
  },
  menuActive: {
    backgroundColor: theme.palette.primary.light,
  },
}))

export default useStyles
